module.exports = __webpack_public_path__ + "static/media/bitterbal_loss.9a29df5c.webp";